<template>
    <div id="generator_result">
        <div class="generator_result">
            <div class="generator_result_1">
                <span class="t-p-r-10">生成内容</span>
                <textLoading v-if="streamStatus"></textLoading>
            </div>
            <div class="aiHistory-btn" @click="getHistroy">
                <img src="@/assets/image/ai_tools/timer.png" alt="">
                <span class="t-p-l-7">历史记录</span>
            </div>
        </div>
        <div class="generator_result1" ref="scrollContainer">
            <noData v-if="showList.length == 0 && resultmarkedText == ''"></noData>
            <div v-else>
                <div class="generator_result1_1">
                    <div class="generator_result1_2" v-for="(item, i) in showList" :key="i">
                        <div class="generator_result1_3">{{ item.paramName }}</div>
                        <div class="generator_result1_4">{{ item.content ? item.content : '无' }}</div>
                    </div>
                </div>
            </div>
            <div class="generator_result1_5" v-html="resultmarkedText"></div>
        </div>
        <div class="generator_result2">
            <div style="width: 200px;">
                <div class="btn-array" v-if="resultmarkedText">
                    <div class="cursor_1 btn_item" v-for="(item, i) in iconResult" :key="i" @click="select(i)">
                        <img :src="item.icon" alt="">
                        <span class="t-p-l-5">{{ item.name }}</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- 停止生成按钮 -->
        <AIStopCreate plain :hide="streamStatus" emit @stop="clearTimer" bottom="90px"></AIStopCreate>
    </div>
</template>
<script>
import data from '@/assets/data';
import { EventBus } from '@/utils/eventBus';
import textLoading from './text_loading.vue';
import noData from './no_data.vue';
import api from '@/api/api';
import { marked } from 'marked';
export default {
    components: {
        noData, textLoading
    },
    data() {
        return {
            iconResult: data.iconResult, //底部图标分享等
            showList: [], //展示数据
            resultText: "", //返回内容
            resultmarkedText: '', //mark内容
            streamStatus: false, //流式请求
            streamIndex: 0, //流式请求下标
            debounceTimer: null, //防抖定时器
            typingTimer: null, // 打字效果定时器
            isStop: false,
        }
    },
    mounted() {
        EventBus.$on('getResult', () => {
            let resultItem = JSON.parse(sessionStorage.getItem('resultItem'))
            this.showList = resultItem.showItem
            this.resultText = ''
            this.resultmarkedText = ''
            this.getNovelstreamId(resultItem.type, resultItem.requestItem)
        })
        EventBus.$on('getHistroy', (id) => {
            this.resultText = ''
            this.resultmarkedText = ''
            this.getHomenovelDetail(id)
        })
        EventBus.$on('clearHistroy', (item) => {
            // console.log(item)
            this.showList = []
            this.resultText = ''
            this.resultmarkedText = ''
        })
        // 监听滚动事件
        this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        this.clearTimer()
        EventBus.$off('getResult');
        EventBus.$off('getHistroy');
        EventBus.$off('clearHistroy');
        // 移除滚动事件监听器
        this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        //获取历史记录详情
        getHomenovelDetail(id) {
            this.showList = []
            api.getHomenovelDetail({ id: id }).then((res) => {
                if (res.code == 200) {
                    let param = JSON.parse(res.data.param)
                    this.resultText = res.data.answer
                    this.resultmarkedText = marked(res.data.answer)
                    // console.log(this.resultmarkedText)
                    if (res.data.param) {
                        api.getTemplate(res.data.questionType).then((items) => {
                            this.showList = items.data.map((item) => {
                                return {
                                    paramKey: item.paramKey,
                                    paramName: item.paramName,
                                    content: param.hasOwnProperty(item.paramKey) ? param[item.paramKey] : ''
                                };
                            })
                        })
                    }

                }
            })
        },
        //停止生成
        clearTimer(status) {
            console.log('销毁定时器')
            if (status) {
                this.isStop = true
                EventBus.$emit('refCount');
            }
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
            this.streamIndex = 0
            this.streamStatus = false;
            localStorage.removeItem('AICreateId')
        },
        getHistroy() {
            this.$emit('openHistroy')
        },
        getNovelstreamId(type, params) {
            this.AIWrite({
                length: '流式工具',
                haveId: false,
                type: type,
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // api.getNovelstreamId(type, params).then((res) => {
            //     if (res.code == 200) {
            //         this.streamStatus = true
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     }
            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamStatus = false
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！')
                                    EventBus.$emit('refCount');
                                    return;
                                }
                                this.getStreamContent(id);
                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.resultText += text[index];
                    this.resultmarkedText = marked(this.resultText);
                    // 每次新内容添加时，自动滚动到最底部
                    this.scrollToBottom();
                    index++;
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        scrollToBottom() {
            const scrollContainer = this.$refs.scrollContainer;
            scrollContainer.scrollTop = scrollContainer.scrollHeight;
        },
        handleScroll() {
            // 当用户手动滚动时，记录当前滚动位置
            const scrollContainer = this.$refs.scrollContainer;
            this.currentScrollTop = scrollContainer.scrollTop;
        },
        select(i) {
            // console.log(this.resultText)
            if (this.streamStatus) {
                this.$message.warning('请等待AI生成完成！')
                return
            }
            if (i == 0) {
                const time = new Date().getTime();
                const fileName = `${time}.txt`;
                const element = document.createElement('a');
                const file = new Blob([this.resultText], { type: 'text/plain' });
                element.href = URL.createObjectURL(file);
                element.download = fileName;
                element.click();
                URL.revokeObjectURL(element.href);
            } else if (i == 1) {
                this.$copyText(this.resultText).then(() => {
                    this.$message.success('复制成功');
                }).catch(() => {
                    this.$message.warning('复制失败');
                })
            }
        }
    }
}
</script>
<style>
#generator_result {
    margin-left: 10px;
    flex: 1;
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 4px 0 0 4px;
    position: relative;
}

.generator_result {
    width: 100%;
    height: 67px;
    font-weight: bold;
    font-size: 17px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #DDDDDD;
}

.generator_result_1 {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.generator_result1_1 {
    border-bottom: 1px solid #BBBBBB;
}

.generator_result1_2 {
    display: flex;
    font-size: 16px;
    margin-bottom: 15px;
}

.generator_result1_3 {
    color: #555555;
}

.generator_result1_4 {
    color: #111111;
    margin-left: 23px;
    flex: 1;
    max-width: 875px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.generator_result1_5 {
    margin-top: 20px;
}

.generator_result_1 img {
    margin-left: 4px;
    width: 21px;
    height: 21px;
}

.generator_result1 {
    width: 100%;
    height: calc(100% - 138px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 15px;
    position: relative;
}

.generator_result2 {
    height: 69px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #DDDDDD;
    font-size: 15px;
}

.generator_result2_1 {
    display: flex;
    align-items: center;
}

.btn-array {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* gap: 24px; */
}

/* .generator_result2_1 img {
    width: 58px;
    height: 58px;
    margin: 0 29px;
} */
</style>